export {};

$(init);

const srcMap = {};

function init() {
    $('.governance-scheme').each(eachGovernanceScheme);
}

function eachGovernanceScheme(schemeIndex, Scheme) {
    const self = $(this);


    const $scheme = $(Scheme);
    let height;

    const $boxConnectSibling =
        $scheme
            .find('.governance-scheme__line--connect-sibling')
            .closest('.governance-scheme__box-simple');

    function getHeightboxConnectSibling() {
        height = 0;

        $boxConnectSibling.each(function each(index, el) {

            if($(el).innerHeight() > height) {
                height = $(el).innerHeight()
            }
        });

        if(height != 0) $boxConnectSibling.innerHeight(height);
    };

    getHeightboxConnectSibling();

    $(window).on('resize', () => {
        setTimeout(getHeightboxConnectSibling, 100)
    });
};



// WEBPACK FOOTER //
// ./js/main/module/governance-scheme.js